// extracted by mini-css-extract-plugin
export var abstract = "DocumentHighlight-module--abstract--e48a7";
export var arrow = "DocumentHighlight-module--arrow--18770";
export var arrowNo = "DocumentHighlight-module--arrow_no--1f615";
export var arrowYes = "DocumentHighlight-module--arrow_yes--61c5b";
export var bordered = "DocumentHighlight-module--bordered--19841";
export var documentHighlight = "DocumentHighlight-module--documentHighlight--5af82";
export var documentImage = "DocumentHighlight-module--documentImage--4b23b";
export var flex = "DocumentHighlight-module--flex--734e0";
export var flex1 = "DocumentHighlight-module--flex_1--84b2c";
export var flexCenter = "DocumentHighlight-module--flex_center--46de1";
export var flexCenterCol = "DocumentHighlight-module--flex_center_col--6ed7f";
export var flexCol = "DocumentHighlight-module--flex_col--c4730";
export var flexFixCenterCol = "DocumentHighlight-module--flex_fix_center_col--d550a";
export var flexFixedCenterCol = "DocumentHighlight-module--flex_fixed_center_col--d4c3d";
export var noPadding = "DocumentHighlight-module--noPadding--36258";
export var padding = "DocumentHighlight-module--padding--d4ecd";
export var publishingInformationLabel = "DocumentHighlight-module--publishingInformationLabel--2e743";
export var rotating = "DocumentHighlight-module--rotating--8d23e";
export var title = "DocumentHighlight-module--title--48043";
export var viewFullAbstractLink = "DocumentHighlight-module--viewFullAbstractLink--36030";